export default __webpack_public_path__ + "static/12.02-c75624429ad71917255a68a46cab2df3.png";